import { useCallback, useContext } from 'react'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { AuthContext } from 'src/context/authContextState'
import { canAccessPage, canAccessPageCapability } from './pageAccessRules'

export const usePageAccessChecker = (): ((
  capability: CAPABILITY,
) => boolean) => {
  const {
    authCtx: { permissions, email },
  } = useContext(AuthContext)
  return useCallback(
    (capability) => canAccessPageCapability(permissions, email, capability),
    [permissions, email],
  )
}

export const usePageAccess = (capability: CAPABILITY): boolean =>
  usePageAccessChecker()(capability)

export const usePageDestinationAccess = (): ((
  destination: string,
) => boolean) => {
  const { authCtx: auth } = useContext(AuthContext)
  return useCallback((destination) => canAccessPage(auth, destination), [auth])
}
